export class AttributeSettingsDTO {
  id?: number;
  key: number;
  value?: number;
  numericValue?: number;
  priority: number;

  constructor(key: number, value?: number, numericValue?: number, id?: number, priority = 0) {
    this.key = key;
    this.value = value;
    this.id = id;
    this.numericValue = numericValue;
    this.priority = priority;
  }
}
